import { render, staticRenderFns } from "./PropertyChangedYN.vue?vue&type=template&id=0ef73e7a"
import script from "./PropertyChangedYN.vue?vue&type=script&lang=js"
export * from "./PropertyChangedYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports